
    import infoList from './infoList.vue'
    import componentTitle from './componentTitle.vue'
    import {useStore} from "@/store";
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";

    interface State {
        dataList: object[];
    }

    export default defineComponent({
        name: "BaseInfo",
        components: {
            infoList,
            componentTitle
        },
        setup() {
            let state: State = reactive({
                dataList: [],
            })
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {basicItemInfos} = data
                state.dataList = basicItemInfos
            })
            return {
                state
            }
        }
    })
